import React from "react";
import { Button, Card } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import FormatDate from "go-core/components/Formatters/FormatDate";
import {
	CrashReportApi,
	CrashReportOccurrenceApi,
} from "../../../../../../../../../../../../../../../services/Api/Admin/adminTypes";

interface Props {
	crashReport: CrashReportApi;
}

const CrashReportOccurrencesCard = ({ crashReport }: Props) => {
	const { t } = useTranslation("admin");
	const history = useHistory();

	const drawOrganizationName = (item: CrashReportOccurrenceApi) => {
		const id = item.organization_name?.substring(
			item.organization_name.indexOf("(") + 1,
			item.organization_name.indexOf(")")
		);
		const name = id ? item.organization_name.split(`(${id}`)[0] : item.organization_name;
		return (
			<div>
				{name}
				{id && <span className="me-2">{id.split("=").join(" ")}</span>}
			</div>
		);
	};

	return (
		<Card className="mt-3 mb-3">
			<Card.Header>{t("modules.crash_report.field.occurrences.header.title")}</Card.Header>
			<Card.Body>
				<table className="table table-preview">
					<thead>
						<tr>
							<th>{t("modules.crash_report.field.app_name.title")}</th>
							<th>{t("common.word.app_version")}</th>
							<th>{t("common.word.terminal")}</th>
							<th>{t("modules.crash_report.field.created_at.title")}</th>
							<th>{t("lib:common.word.venue")}</th>
							<th />
						</tr>
					</thead>
					<tbody>
						{crashReport.occurrences.map((occurrence, index) => {
							return (
								<tr key={index}>
									<td>{occurrence.app_name}</td>
									<td>{occurrence.app_version}</td>
									<td>{occurrence.terminal ? occurrence.terminal : ""}</td>
									<td>{FormatDate(occurrence.created_at)}</td>
									<td>{drawOrganizationName(occurrence)}</td>
									<td>
										<Button
											variant="light"
											onClick={() => {
												history.push(`/admin/crash_reports/occurrences/${occurrence.id}`);
											}}
										>
											{t("common.action.preview", { ns: "lib" })}
										</Button>
									</td>
								</tr>
							);
						})}
					</tbody>
				</table>
			</Card.Body>
		</Card>
	);
};

export default CrashReportOccurrencesCard;
